import { TransformState } from '../types';

export const calculateZoom = (current: number, delta: number, min: number = 0.2, max: number = 5): number => {
  const next = Math.max(min, Math.min(max, current + delta));
  return Math.round(next * 1000) / 1000;
};

export const applyTransform = (element: HTMLElement, transform: TransformState): void => {
  element.style.transform = `translate(${transform.position.x}px, ${transform.position.y}px) scale(${transform.scale}) rotate(${transform.rotation}deg)`;
};

export const getTransformStyle = (transform: TransformState): string => {
  return `translate(${transform.position.x}px, ${transform.position.y}px) scale(${transform.scale}) rotate(${transform.rotation}deg)`;
};

export const createInitialTransform = (): TransformState => ({
  scale: 1,
  rotation: 0,
  position: { x: 0, y: 0 }
});

export const resetTransform = (): TransformState => createInitialTransform(); 